import React, { Component } from 'react';
import styled from 'styled-components';
import {connect} from 'react-redux';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import { Button, Form,  Segment, Sidebar, Menu, Icon } from 'semantic-ui-react'
import Formmessage from '../content/message'

import Content from '../content'


import {Appmain, Unitfull, Unitfullanimaton, Unit, Unitsblock, Unittext, UnittextOp, Titletext } from './normal-style';

import Menubar from './menubar'


class TitleBodyNormal extends Component {

  constructor(props){

    super(props)

    this.state={

        unith:null,
        anim:false, //открытие окна
        animationNormal:false, // ... с полной анимацией
        unitx:0,
        unity:0,
        unit:null,
        paddingtop:null,
        unitfullh: null,
        menudraw:false,

    }
  }

componentDidMount(){
      window.addEventListener("resize", this.resize.bind(this));
      this.resize();
}


resize() {

    this.setState({

        unith: Math.round((window.innerHeight)/8)+'px',

        unitfullh: Math.round((window.innerHeight)-70)+'px',
        paddingtop: Math.round((window.innerHeight)/380)+5+'px'
    })

}


unit1draw(){
    this.setState({unit1:!this.state.unit1})
}



getDrawParam(unit){

console.log('unit'+unit);
  var obj = document.getElementById(unit);

      this.setState({


        unitx: obj.offsetLeft+'px',
        unity: obj.offsetTop,
        anim:false

      })
}



noanimation = ()=>{

  this.setState({

      anim:true,
      menudraw:false
  })
}

handleShowClick = () => {
    console.log('do'+this.state.menudraw);

      this.setState({ menudraw: !this.state.menudraw } )


}

render (){

    const {menudraw, unitx,  unity, animationNormal, anim, messageinputdraw, classvariantbool, unit, unith, paddingtop, unitfullh} = this.state
    const {titleunits, winwidth, winheight} = this.props
    const unitparam={
       paddingtop:paddingtop,
       bool:this.state.unit1,
       unith:unith,
       unitwidth: this.state.unitwidth,
       unity:this.state.unityL1
    }
    const drawparam = { 'extrasmall':false, 'winwidth':winwidth, 'winheight':winheight, 'normalstyle':true}

    return (
      <div>
        <Router>
        <Menubar drawparam={drawparam} callback={this.handleShowClick} />

         <Sidebar.Pushable as={Segment} style={{'position':'relative', 'top':'-14px'}}>
             <Sidebar style={{'background':'#040445'}}
                     as={Menu}
                     animation='overlay'
                     icon='labeled'
                     inverted
                     onHide={this.handleSidebarHide}
                     vertical
                     visible={menudraw}
                     width='200px'
                   >
                   <Menu.Item as='a' style={{'color':'#cdc9e7', 'font-weight': 'bold'}}>

                           <Icon onClick={()=>this.setState({menudraw:false})}  name='long arrow alternate left' />

                   </Menu.Item>
                      {titleunits.map((unit)=>
                        <Link to={'/'+unit.id+'/'} onClick={this.noanimation} >
                          <Menu.Item as='a' style={{'color':'#dddae8', 'font-weight': 'bold'}}>

                                  {unit.unitname}

                          </Menu.Item>
                        </Link>
                      )
                    }

               </Sidebar>

               <Sidebar.Pusher>




                { classvariantbool ?
                  null
                  :
                  titleunits.map((unit)=>
                    <Route path={"/"+unit.id+"/"} render={()=>{
                      setTimeout(()=> {
                        this.setState({

                              anim:true

                        })

                      }, 50);

                          return(
                          <Unitfull winwidth={winwidth} winheight={winheight}  bool={anim} unitx={unitx} unitfullh={unitfullh} unity={unity} >
                            <div className='contentheader'>
                                <div >
                                      &nbsp;
                                </div>

                                          <Formmessage/>


                                <div className='contentheaderlink'>
                                        <Link to="/" onClick={this.noanimation.bind(this)} >(Закрыть)</Link>
                                </div>

                            </div>
                          <Content winheight={winheight} unit={unit.id} />

                          </Unitfull>
                        )


                      }

                         }/>
                   )
                 }


                <Unitsblock>

                      {this.props.titleunits.map((text, index) => (


<Link to={'/'+text.id+'/'} onClick={()=>this.getDrawParam(text.id)} >
                              <Unit id={text.id}  paddingtop={paddingtop} bool={this.state.unit1} unith={unith} winheight={winheight} winwidth={winwidth} unity={this.state.unityL1}  >

                                  <div  style={{'cursor':'pointer'}}>

                                          <Unittext winwidth={winwidth} winheight={winheight}>{text.unitname} </Unittext>
                                          <UnittextOp winwidth={winwidth} winheight={winheight}>{text.unitdescr}</UnittextOp>

                                  </div>

                              </Unit>
                              </Link>

                      ))}


                      <Titletext winwidth={winwidth}>Тульский областной центр новых информационных технологий является структурным подразделением государственного образовательного учреждения высшего профессионального образования <br /> "Тульский государственный университет" (ТулГУ)</Titletext>

                </Unitsblock>


    </Sidebar.Pusher>
  </Sidebar.Pushable>
</Router>
    </div>
  );
}
}

export default connect(
  state => ({

        titleunits:state.titleunits,

  }),

)(TitleBodyNormal);
